import styled from 'styled-components';
import { motion } from "framer-motion";

export const Wrapper = styled(motion.div)`
  min-height: 33.4rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Title = styled.h1`
  ${(props) => props.theme.fonts.interBold42};
  color: ${(props) => props.theme.colors.white100};
  user-select: none;
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${window.location.origin}/banners/${(props) => props.game}.webp);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  -webkit-mask-image: -webkit-linear-gradient(90deg, rgba(20, 20, 26, 0) 10%, rgb(20, 20, 26) 100%);
  opacity: .1;
  pointer-events: none;
`;

export const Filters = styled.div`
  margin-top: 1.6rem;
  display: flex;
  gap: .8rem;
`;